import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { configs } from '../../../constants/configs/configs';

import { processCommon } from '../../../utils/dashboard/processCommon';
import Tooltip from '../../common/tooltip/Tooltip';

const AppStatus = (props) => {

    const { routes } = configs;
    const { data, onCTAHandler, householdIdDetails, showTobaccoStatus=false } = props;
    const { applicants, applicationYear, status, links } = data;

    const handleClick = (e, link) => {
        e.preventDefault();
        onCTAHandler(link);
    };
    
    const {
        householdCaseId,
        stateCode
    } = householdIdDetails;

    const caseId = householdCaseId && householdCaseId !== '0' ? householdCaseId : false;

    const getLinks = (links) => {
        return links.map((link, index) => (
            <div className="text-underline links-margin-b" key={index}>
                <a id={`application_status_link_${index}`} href="#"
                    onClick={(e) => handleClick(e, link)}
                >
                    <FormattedMessage id={link}/>
                </a>
            </div>
        ));
    };
    
    return (
        <div id="auto-app-status" className="gi-panel">
            <div className="">
                <div className="grid-row">
                    <h4 id="application_status_header" data-automation-id="application_status_header">
                        <FormattedMessage id="application_status.header"/>&nbsp;
                    </h4>
                    <div id="application_status_header_householdId_wrapper" className="gi-application_status_header_householdId_txt">
                        { caseId && stateCode !== 'ID' &&
                            <Fragment>
                                (<FormattedMessage id="application_status.header.householdId"/>
                                <span className="gi-application_status_header_householdId" data-automation-id="householdId">
                                    { caseId }
                                </span>)
                            </Fragment>
                        }

                    </div>
                </div>
                <div className="grid-row padding-2">
                    <div className="tablet:grid-col-5 padding-x-2">
                        <div className=""
                            id="application_status_year"
                        >
                            <FormattedMessage id="application_status.application_year" values={{ applicationYear }}/>
                        </div>
                        {applicants && applicants.length > 0 &&
                            <Tooltip
                                id='plans.for.member'
                                content={processCommon.getEnrolleesNames(applicants)}
                                index='app_status'
                                replacement={{ numMember: applicants.length }}
                                place='left'
                                contentClassName='gi-txt__capitalize'
                            />
                        }
                    </div>
                    <div className="tablet:grid-col-4 padding-x-2">
                        <div className="" id="application_status_value">
                            <FormattedMessage id={status}/>
                        </div>
                    </div>
                    <div className="tablet:grid-col-3 padding-x-2">
                        { getLinks(links) }
                        
                        <br/>
                        { showTobaccoStatus &&
                            <div className="text-underline tobacco_status">
                                <a href={routes.TOBACCO}><FormattedMessage id="tobacco_status"/></a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppStatus;